import styled from 'styled-components';

interface DepartmentCardProps {
  width?: number;
}

export const Container = styled.div<DepartmentCardProps>`
  width: 32.2%;
  min-width: 26rem;
  ${(props) =>
    props.width !== undefined &&
    ` //Aplica somente no componente de transferir
    width:${props.width}% !important;
    min-width: -webkit-fill-available !important;
  `}

  .department-created {
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.colors.background} 0% 0% no-repeat padding-box;
    border-radius: 16px;
    opacity: 1;
    justify-content: space-between;
    padding: 0.3rem 0.7rem;
    gap: 0.5rem;

    .department-name {
      text-align: left;
      font-size: 20px;
      font-weight: 700;
      font-family: 'Futura PT';
      letter-spacing: 0px;
      color: ${({ theme }) => theme.colors.primary};
      opacity: 1;
      display: flex;
      text-align-last: center;
      width: 60%;
      ${(props) =>
        props.width !== undefined &&
        `
        width:${props.width}% !important;
      `}

      .name {
        ${(props) =>
          props.width !== undefined &&
          `
          width:${props.width}% !important;
          text-align-last: center !important;
        `}
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 92%;
        text-align-last: start;
        justify-content: center;
      }
    }

    .department-options {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 40%;

      .radio-buttons {
        color: ${({ theme }) => theme.colors.text};
        display: flex;
        flex-direction: row;
        align-items: center;

        span {
          color: ${({ theme }) => theme.colors.tertiary_500};
          padding: 0;
        }

        p {
          margin: 0;
          padding: 0;
          margin-right: 0.2rem;
          font-size: 12px;
        }
      }
    }

    .icon-options {
      display: flex;

      svg {
        color: ${({ theme }) => theme.colors.tertiary_500};
        opacity: 1;
      }
    }
  }

  @media (max-width: 410px) {
    width: 100%;
    min-width: 0;

    .department-created {
      flex-direction: column;

      .department-name {
        width: 100%;

        .name {
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align-last: center;
          ${(props) =>
            props.width !== undefined &&
            ` //Aplica somente no componente de transferir
            font-size: 13px;
          `}
        }
      }
    }
  }
`;
